import Vue from 'vue'
import i18n from '@/lang'
// 翻译
Vue.filter('translateFilter', function (value, separator = '/') {
  if (!value) return
  return value.split(separator).map(item => i18n.t(item)).join(separator)
})
